import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGlobalNewPpsis } from '../actions';
import { getGlobalPpsis, getIsFetching } from '../selectors';

const useGlobalNewPpsis = withStatus => {
  const dispatch = useDispatch();
  const isFetching = useSelector(getIsFetching);
  const globalPpis = useSelector(getGlobalPpsis);

  useEffect(() => {
    console.log('NEW NEW NEW PPSIS qithstatus', withStatus);
    console.log('Status value for PPSIS', withStatus);
    const filter = {};
    if (withStatus) {
      filter.status = withStatus;
    }
    console.log('REq PPSIS filter', filter);
    dispatch(fetchGlobalNewPpsis({ filter }));
  }, [dispatch]);

  return [isFetching, globalPpis];
};

export default useGlobalNewPpsis;
